import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleWideSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-wide-sparkle, message, chat"><path d="M12.75 3.75H2.75V18.25H9.0155L11.9979 20.75L15.0155 18.25H21.25V12.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleWideSparkle;
